import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes, IncidentsService, IncidentTypes, LabelValue, Modal, StringDateTimePipe, TableTypes } from 'common-cloudstudio';
import { IncidentService } from '../services/incident.service';
import { IncidentElementModalComponent } from '../incident-shared/incident-element-modal/incident-element-modal.component';
import { NgForm } from '@angular/forms';
import moment from 'moment';
export interface ITS_PersonsData extends CoreTypes.ITS_IncidentPersons, CoreTypes.ITS_Persons {
  VehicleDataID?:number,
  Id?: number
 }

@Component({
  selector: 'app-incident-file',
  templateUrl: './incident-file.component.html',
  styleUrls: ['./incident-file.component.scss'], 
})

export class IncidentFileComponent implements OnInit, OnDestroy {
  today = new Date();

  @ViewChild("formElement") public _formElement: NgForm;
  @ViewChild('elementModal') private _elementModal: IncidentElementModalComponent;
  @ViewChild('confirmRemove') private _confirmRemove: Modal;
  @Input() incidentID: number = 0;
  communicationID : number = 0;

  @Output() onCloseForm = new EventEmitter<any>();

  incidentData: CoreTypes.ITS_Incident;
  _incidentTypeFullList: CoreTypes.IncidentType[] = [];
  _incidentTypeList: LabelValue<number>[] = []
  _incidentSubTypeFullList: CoreTypes.IncidentSubType[]= [];
  _incidentSubTypeList: LabelValue<number>[] = [];
  incidentCategoryColorList: LabelValue<number>[] = [];
  
  incidentColorFullList: CoreTypes.InternalColorWithDefaultGroup[] = [];
  incidentCategoryColor: LabelValue<number> = this.incidentCategoryColorList[0];
  incidentFileData:  any;

  _fatalVictimsList: LabelValue<number>[] = [];
  _fatalVictims:LabelValue<number>;
  _tracksAffectedList: LabelValue<number>[] = [];
  _tracksAffected: LabelValue<number>;
  _byPassList: LabelValue<number>[] = [];
  _byPass: LabelValue<number>;
  _trafficCutList: LabelValue<number>[] = [];
  _trafficCut: LabelValue<number>;
  _accidentTypeList: LabelValue<number>[] = [];
  _accidentType: LabelValue<number>;
  _relativeLocationList: LabelValue<number>[] = [];
  _relativeLocation: LabelValue<number>;
  _hardPointList: LabelValue<number>[] = [];
  _hardPoint: LabelValue<number>;
  _roadDefensesList: LabelValue<number>[] = [];
  _roadDefenses: LabelValue<number>;
  _unevennessList: LabelValue<number>[] = [];
  _unevenness: LabelValue<number>;
  _fenceStateList: LabelValue<number>[] = [];
  _fenceState: LabelValue<number>;
  _roadWorksList: LabelValue<number>[] = [];
  _roadWorks: LabelValue<number>;
  _maximumSectorSpeedList: LabelValue<number>[] = [];
  _maximumSectorSpeed: LabelValue<number>;
  _roadConditionList: LabelValue<number>[] = [];
  _roadCondition: LabelValue<number>;
  _atmosphericStateList: LabelValue<number>[] = [];
  _atmosphericState: LabelValue<number>;
  _luminosityStateList: LabelValue<number>[] = [];
  _luminosityState: LabelValue<number>;
  _artificialLightList: LabelValue<number>[] = [];
  _artificialLight: LabelValue<number>;
  _probableCauseList: LabelValue<number>[] = [];
  _probableCause: LabelValue<number>;

  _vehiclesInvolved: TableTypes.DataTable = { Columns: [], Elements: [] };
  _vehiclesInvolvedList: any[] = [];
  _vehiclesInvolvedListClone: IncidentTypes.ITS_VehiclesData[] = [];
  _peopleInvolved: TableTypes.DataTable = { Columns: [], Elements: [] };
  _peopleInvolvedList: any[] = [];
  _peopleInvolvedListClone: ITS_PersonsData[] = [];
  _lanesInvolvedTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _dispatchTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _dispatchList: any[] = [];
  _summaryTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _summaryList: any[] = [];
  _lanesInvolvedList: any[] = [];
  _fileEvidenceTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _fileEvidenceList: any[] = [];
  _damageRegisterDataTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _damageRegisterList: any[] = [];
  _vehiclePersonList: LabelValue<number>[] = [{label: 'Ninguno',value: 0}];
  _vehiclePerson: LabelValue<number>;
  _externalMovilList: LabelValue<number>[] = [];
  _movilList: LabelValue<number>[] = [];
  _assistanceList: LabelValue<number>[] = [];
  _laneRoadwayList: LabelValue<number>[] = [];
  _laneRoadway: LabelValue<number>;
  _trafficDirections: LabelValue<number>;
  _laneFullList: CoreTypes.ITS_Lanes[] = [];
  _reasonLaneCloseList: LabelValue<number>[] = [];
  _reasonLaneOpenList: LabelValue<number>[] = [];

  _laneClone: CoreTypes.ITS_IncidentLanes = new CoreTypes.ITS_IncidentLanes();
  _assistanceClone: CoreTypes.ITS_IncidentAssistanceDispatch = new CoreTypes.ITS_IncidentAssistanceDispatch();
  involvedVehicleClone: IncidentTypes.ITS_VehiclesData = { ...new CoreTypes.ITS_VehiclesData(), ...new CoreTypes.ITS_Persons(), ...new CoreTypes.ITS_IncidentVehicles() };
  involvedPerson: ITS_PersonsData = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  involvedPersonClone: ITS_PersonsData = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  damageRegister: CoreTypes.ITS_IncidentDamagedMaterialAssets = new CoreTypes.ITS_IncidentDamagedMaterialAssets();

  _vialAxesFullList: CoreTypes.ITS_VialAxes[];
  _roadwayFullList: CoreTypes.ITS_Roadways[] = [];
  _trafficDirectionsList: LabelValue<number>[] = [];
  _trafficDirectionsFullList:CoreTypes.ITS_TrafficDirection[] = [];
  _sectorFullList:CoreTypes.ITS_Sectors[] = [];
  _subSectorFullList:CoreTypes.ITS_SubSectors[] = [];

  _editId: number;
  _editType: string;
  _editTitle: string;
  _removeId: number;
  _removeType: string;

  loadDataVehicles = 0;
  loadDataLanes = 0;
  loadAssistances = 0;
  loadAddVehicles = 0;
  loadDataPersons = 0;
  loadAddPersons = 0;

  incidentElements: IncidentTypes.IncidentElementModal;
  incidentElementTypes = IncidentTypes.elementTypes;

  constructor(
    private appService: AppService,
    private incidentService: IncidentService,
    private incidentsService: IncidentsService,
    private _coreProxyService: CoreProxyService,
    private cdRef: ChangeDetectorRef,
    private stringDateTimePipe: StringDateTimePipe,

  ) {}

  ngOnInit(): void {
   this.setInitData();
    this.appendModalBody('append');

  }

  ngOnDestroy(): void {
    this.appendModalBody('remove');
    
  }

  setInitData() {
    this.getIncidentTypes();
    this.getColorsAllowedForIncidents();
    this.getITSRoadways();
    this.onSelectTrafficDirection();
    this.getSectorList();
    this.refreshTabsData();
  }

  async getIncidentTypes() {
    this._incidentTypeList = [];
    this.incidentService.getIncidentTypes().then(async (incidentTypes) => {
      this._incidentTypeFullList = incidentTypes;
      this._incidentTypeList = await this.incidentService._incidentTypeList.value;
      if(incidentTypes.length) {
        this.getIncidentSubTypes(this._incidentTypeList[0]?.value);
      }
    });
  }

  getIncidentSubTypes(incidentType) {
    this._incidentSubTypeList = [];
    if(!incidentType) return;
    let items: LabelValue<number>[] = [];
    this._coreProxyService.IncidentService.EnumIncidentSubTypes(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      incidentType,
      (data:CoreTypes.IncidentSubType[]) => {
        this._incidentSubTypeFullList = data;
        data.forEach((i) => {
          const item = {
            label: i.Description ? i.Description : i.SubtypeName,
            value: i.IncidentSubTypeID,
          };
          if (
            this.incidentData?.Incident?.SubTypeID === i.IncidentSubTypeID || items.length === 0) {
            // this._incidentSubType = item;
          }
          items.push(item);
        });
        this._incidentSubTypeList = items;
        // this._incidentSubType = this._incidentSubTypeList.find(i => i.value === this.incidentData.Incident.SubTypeID)?? this._incidentSubTypeList[0];
      },
      err => {
        this.appService.showException(err);
      }
    );
  }

  async getColorsAllowedForIncidents() {
    this.incidentsService.getColorsForIncidentsWithGroup().then(async incidentColors => {
      this.incidentColorFullList = incidentColors;
      this.incidentCategoryColorList = await this.incidentsService._colorsWithGroupList?.value;
      this.incidentID ? this.incidentCategoryColor = this.incidentCategoryColorList?.find(i => i.value === this.incidentData?.Incident?.ColorID) :
      this.incidentCategoryColor = this.incidentCategoryColorList?.find(i => i.value === this.appService.client?.Client?.IncidentSettings?.DefaultIncidentColorID)?? this.incidentCategoryColorList[0];
  
    });
  }

  getITSRoadways() {
    this._roadwayFullList = [];
    this.cdRef.detectChanges();
    this.incidentService.getITSRoadways().then(async roadwayList => {
      this._roadwayFullList = roadwayList;
      // this._roadway = this._roadwayList.find(i => this.incidentData.ReferencePoint?.RoadwayID === i.value) ?? this._roadwayList[0];
      // this.incidentService._roadway = this._roadway;
      this.cdRef.detectChanges();
      this.onSelectVialAxes();
    });
  }

  async onSelectVialAxes() {
    this._vialAxesFullList = await this.incidentService.getITSVialAxes();
    let items: LabelValue<number>[] = [];
    this._vialAxesFullList?.forEach((i) => {
      const item = {
        label: i.VialAxisName,
        value: i.VialAxisID,
      };
      items.push(item);
    });
    this.incidentService._vialAxesList = items;
    this.cdRef.detectChanges();
  }

  async onSelectTrafficDirection() {
    await this.incidentService.getITSTrafficDirections();
    this._trafficDirectionsFullList = await this.incidentService._trafficDirectionsList.value;
    this.cdRef.detectChanges();
  }

  async getITSExternalAssistanceServices() {
    this._externalMovilList = [];
    // this._externalMovilFullList = [];
    this._externalMovilList = await this.incidentService.getITSExternalAssistanceServices();
    // this._externalMovilFullList = await this.incidentService._externalServiceList.value;
  }
  
  async getITSReasonsClosing() {
    await this.incidentService.getITSReasonsClosing();
    this._reasonLaneCloseList = await this.incidentService._reasonCloseList.value;
  }

  async getITSReasonsOpening() {
    await this.incidentService.getITSReasonsOpening();
    this._reasonLaneOpenList = await this.incidentService._reasonOpenList.value;
  }

  async getSectorList() {
    this._sectorFullList = await this.incidentService.getSectorList();
    let sectorList = await this.incidentService._sectorList.value;
    const sector =  sectorList.find(s => s.value ===  this.incidentData?.Incident?.SectorID) ?? sectorList[0];
    this.getSubSectorList(sector?.value);
  }

  getSubSectorList(sectorID: number) {
    if(!sectorID) return;
    // let items: LabelValue<number>[] = [];
    this._coreProxyService.IncidentService.EnumITSSubSectorsBySectorID(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      sectorID,
      (data:CoreTypes.ITS_SubSectors[]) => {
        this._subSectorFullList = data;;
      },
      err => {
        this.appService.showException(err);
      }
    );
  }
  
  openEditSelectedElement(id, editType, title?) {
    this._editId = id;
    this._editType = editType;
    this._editTitle = title;
    this.updateMaxDate();
    switch (this._editType) {
      case 'dispatch':
        this._assistanceClone = new CoreTypes.ITS_IncidentAssistanceDispatch();
        this._assistanceClone = JSON.parse(JSON.stringify(this.incidentData.Dispatches[id]));
        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.Dispatches,
          JsonData: JSON.stringify(this._assistanceClone),
          Editing: true,
          IncidentID: this.incidentID
        }
        this._elementModal.open(this.incidentElements);
        break;
      case 'lanes':
        this._laneClone = new CoreTypes.ITS_IncidentLanes();
        this._laneClone = JSON.parse(JSON.stringify(this.incidentData.IncidentLanes[id]));

        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.Lanes,
          JsonData: JSON.stringify(this._laneClone),
          Editing: true,
          IncidentID: this.incidentID
        }
        this._elementModal.open(this.incidentElements);
        break;
      case 'vehicle':
        this.involvedVehicleClone = { ...new CoreTypes.ITS_VehiclesData(), ...new CoreTypes.ITS_Persons(), ...new CoreTypes.ITS_IncidentVehicles() };
        this.involvedVehicleClone = JSON.parse(JSON.stringify(this._vehiclesInvolvedListClone[id]));
        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.InvolvedVehicles,
          JsonData: JSON.stringify(this.involvedVehicleClone),
          Editing: true,
          IncidentID: this.incidentID
        }
        this._elementModal.open(this.incidentElements);
        break;
      case 'people':
        this.involvedPersonClone = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
        this.involvedPersonClone = JSON.parse(JSON.stringify(this._peopleInvolvedListClone[id]));
        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.InvolvedPeople,
          JsonData: JSON.stringify(this.involvedPersonClone),
          Editing: true,
        }
        this._elementModal.open(this.incidentElements);
        break;
      case 'damages':
        this.damageRegister =  new CoreTypes.ITS_IncidentDamagedMaterialAssets();
        this.damageRegister.MaterialAssetID = this._damageRegisterList[this._editId]?.Id,
        this.damageRegister.Quantity = this._damageRegisterList[this._editId]?.Quantity,
        this.damageRegister.Comments = this._damageRegisterList[this._editId]?.Comments

        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.DamageRegister,
          JsonData: JSON.stringify(this.damageRegister),
          Editing: true,
          IncidentID: this.incidentID
        }
        this.cdRef.detectChanges();
        this._elementModal.open(this.incidentElements);
        break;
      case 'file':
        let file = this._fileEvidenceList[id];
        this.incidentElements = {
          IncidentElementTypeID: this.incidentElementTypes.Files,
          JsonData: JSON.stringify(file),
          Editing: true,
          IncidentID: this.incidentID
        }
        this.cdRef.detectChanges();
        this._elementModal.open(this.incidentElements);
        break;
      default:
      break;
    }
  }

  openRemoveModal(id, removeType) {
    // this.disableDeleteButton = true;
    this._removeId = id;
    this._removeType = removeType;
    this._confirmRemove.open();
  }


  openAddModal(type: any) {
    this.incidentElements = null;
    this.incidentElements = {
      IncidentElementTypeID: type,
      JsonData: '',
      Editing: false,
      IncidentID: this.incidentID
    }
    this.cdRef.detectChanges();
    this._elementModal.open(this.incidentElements);
  }
  
  downloadFileTable(pos) {
    this._fileEvidenceList[pos]?.Url ? this.appService.downloadFiles(this._fileEvidenceList[pos]?.Url, this._fileEvidenceList[pos]?.Url) :
    this.appService.downloadFiles(this._fileEvidenceList[pos]?.File, this._fileEvidenceList[pos]?.FileName)
  }

  onCloseSettings(event) {
    setTimeout(() => this.incidentElements = null, 100);
  }
  
  async addDispatch(assistance: CoreTypes.ITS_IncidentAssistanceDispatch) {
    let movilID = assistance.VehicleID ? assistance.VehicleID : assistance.ServiceID;
    if (assistance && movilID != 0) {
      let exist = this._dispatchList.find(x => x.Id == movilID);
      if (!exist){
        if(!this._externalMovilList.length) await this.getITSExternalAssistanceServices();
        let movil = assistance.VehicleID ? this._movilList.find(m => m.value == assistance.VehicleID) : this._externalMovilList.find(e => e.value === assistance.ServiceID);
        let assistanceType = this._assistanceList.find(a => a.value === assistance.AssistanceType);
        // if(!this.incidentData?.Dispatches?.length) { this.incidentData.Dispatches = []; }
        // this.incidentData?.Dispatches.push({
        //   ArrivalDateTime: assistance.ArrivalDateTime?.Date?.Day ? assistance.ArrivalDateTime : new CoreTypes.DateTimeDT(),
        //   AssistanceType: assistance.AssistanceType,
        //   DepartureDateTime: assistance.DepartureDateTime?.Date?.Day ? assistance.DepartureDateTime : new CoreTypes.DateTimeDT(),
        //   DispatchDateTime: assistance.DispatchDateTime,
        //   DispatchID: 0,
        //   EmergencyVehicleID: undefined,
        //   HasArrived: assistance.ArrivalDateTime?.Date?.Day ? true : false,
        //   HasAttended: assistance.DepartureDateTime?.Date?.Day ? true : false,
        //   HasDeparture: assistance.DepartureDateTime?.Date?.Day ? true : false,
        //   IncidentID: this.incidentData.Incident.IncidentID,
        //   LicensePlate: assistance.LicensePlate,
        //   ServiceID: assistance.ServiceID ? assistance.ServiceID : undefined,
        //   VehicleID: assistance.VehicleID ? assistance.VehicleID : undefined,
        //   EndDateTime: assistance.EndDateTime?.Date?.Day ? assistance.EndDateTime : new CoreTypes.DateTimeDT(),
        //   HasEnded:  assistance.EndDateTime?.Date?.Day ? true : false,
        //   Reference: assistance.Reference,
        // });

        // this.incidentData.Dispatches[this.incidentData.Dispatches.length-1]['TransferEndDateTime'] = assistance['TransferEndDateTime'];
        // this.incidentData.Dispatches[this.incidentData.Dispatches.length-1]['Observation'] = assistance['Observation'];
        // this.incidentData.Dispatches[this.incidentData.Dispatches.length-1]['Identification'] = assistance['Identification'];

        if(!this._dispatchList.length) this._dispatchList = [];
        this._dispatchList.push({
          Id: movilID,
          Movil: movil?.label,
          AssistanceType: assistanceType?.label,
          DispatchDateTime: moment(this.stringDateTimePipe.transform(assistance.DispatchDateTime)).format('DD-MM-YYYY HH:mm'),
          ArrivalDateTime: (assistance.ArrivalDateTime && assistance.ArrivalDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(assistance.ArrivalDateTime)).format('DD-MM-YYYY HH:mm') : null,
          DepartureDateTime: (assistance.DepartureDateTime && assistance.DepartureDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(assistance.DepartureDateTime)).format('DD-MM-YYYY HH:mm') : null,
          EndDateTime: (assistance.EndDateTime &&  assistance.EndDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform( assistance.EndDateTime)).format('DD-MM-YYYY HH:mm') : null,
          ServiceID: assistance.ServiceID ? assistance.ServiceID : undefined,
          VehicleID: assistance.VehicleID ? assistance.VehicleID : undefined
        });
        if(!this.incidentService._assistanceDispacthList?.length) this.incidentService._assistanceDispacthList = [];
        let item = {
          Movil : this._dispatchList[this._dispatchList?.length-1]?.Movil,
          ServiceID: this._dispatchList[this._dispatchList?.length-1]?.ServiceID,
          VehicleID: this._dispatchList[this._dispatchList?.length-1]?.VehicleID
        }
        this.incidentService._assistanceDispacthList.push(item);
      }
      this.addItemToSection(this.incidentElementTypes.Dispatches, (assistance.VehicleID ? assistance.VehicleID : assistance.ServiceID));
      setTimeout(() => this.onRefreshGrid('dispatch'), 100);
    }
  }
  
  onEditDispatch(Id) {
    let movil = this._assistanceClone.VehicleID ? this._movilList.find(m => m.value === this._assistanceClone.VehicleID) :
    this._externalMovilList.find(e => e.value === this._assistanceClone.ServiceID);
    let assistance = this._assistanceList.find(a => a.value === this._assistanceClone?.AssistanceType);
    this.removeElementFromTable(this.incidentElementTypes.Dispatches, this._dispatchList[Id].Id);
    let oldID = this._dispatchList[Id].Id;
    let indexDispatch = this.incidentService._assistanceDispacthList.findIndex(x => x.VehicleID == oldID || x.ServiceID == oldID);
    // if(this._assistanceClone.ArrivalDateTime?.Date?.Day) {
    //   this.incidentData.Dispatches[Id].ArrivalDateTime = this._assistanceClone.ArrivalDateTime;
    //   this.incidentData.Dispatches[Id].HasArrived = true;
    // } else {
    //   this.incidentData.Dispatches[Id].ArrivalDateTime = new CoreTypes.DateTimeDT();
    //   this.incidentData.Dispatches[Id].HasArrived = false;
    // }
    // if(this._assistanceClone.DepartureDateTime?.Date?.Day) {
    //   this.incidentData.Dispatches[Id].DepartureDateTime = this._assistanceClone.DepartureDateTime;
    //   this.incidentData.Dispatches[Id].HasDeparture = true;
    // } else {
    //   this.incidentData.Dispatches[Id].DepartureDateTime = new CoreTypes.DateTimeDT();
    //   this.incidentData.Dispatches[Id].HasDeparture = false;
    // }
    // if(this._assistanceClone.DispatchDateTime?.Date?.Day) {
    //   this.incidentData.Dispatches[Id].DispatchDateTime = this._assistanceClone.DispatchDateTime;
    //   this.incidentData.Dispatches[Id].HasAttended = true;
    // } else {
    //   this.incidentData.Dispatches[Id].DispatchDateTime = new CoreTypes.DateTimeDT();
    //   this.incidentData.Dispatches[Id].HasAttended = false;
    // }

    // if(this._assistanceClone.EndDateTime?.Date?.Day) {
    //   this.incidentData.Dispatches[Id].EndDateTime = this._assistanceClone.EndDateTime;
    //   this.incidentData.Dispatches[Id].HasEnded = true;
    // }else {
    //   this.incidentData.Dispatches[Id].EndDateTime = new CoreTypes.DateTimeDT();
    //   this.incidentData.Dispatches[Id].HasEnded = false;
    // }
    // this.incidentData.Dispatches[Id].VehicleID = this._assistanceClone.VehicleID ? this._assistanceClone.VehicleID : undefined
    // this.incidentData.Dispatches[Id].ServiceID = this._assistanceClone.ServiceID ? this._assistanceClone.ServiceID : undefined;

    // this.incidentData.Dispatches[Id].AssistanceType = this._assistanceClone.AssistanceType;
    // this.incidentData.Dispatches[Id].LicensePlate =this._assistanceClone.LicensePlate;
    // this.incidentData.Dispatches[Id].Reference = this._assistanceClone.Reference;

    // this.incidentData.Dispatches[Id]['TransferEndDateTime'] = this._assistanceClone.TransferEndDateTime;
    // this.incidentData.Dispatches[Id]['Observation'] = this._assistanceClone.Observation;
    // this.incidentData.Dispatches[Id]['Identification'] = this._assistanceClone.Identification;


    this._dispatchList[Id].Id = this._assistanceClone.VehicleID ? this._assistanceClone.VehicleID : this._assistanceClone.ServiceID;
    this._dispatchList[Id].Movil = movil?.label,
    this._dispatchList[Id].AssistanceType = assistance?.label
    this._dispatchList[Id].DispatchDateTime = moment(this.stringDateTimePipe.transform(this._assistanceClone.DispatchDateTime)).format('DD-MM-YYYY HH:mm'),
    this._dispatchList[Id].DepartureDateTime = (this._assistanceClone.DepartureDateTime && this._assistanceClone.DepartureDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(this._assistanceClone.DepartureDateTime)).format('DD-MM-YYYY HH:mm') : null,
    this._dispatchList[Id].ArrivalDateTime = (this._assistanceClone.ArrivalDateTime && this._assistanceClone.ArrivalDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(this._assistanceClone.ArrivalDateTime)).format('DD-MM-YYYY HH:mm') : null
    this._dispatchList[Id].EndDateTime = (this._assistanceClone.EndDateTime && this._assistanceClone.EndDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(this._assistanceClone.EndDateTime)).format('DD-MM-YYYY HH:mm') : null
    this.addItemToSection(this.incidentElementTypes.Dispatches, this._dispatchList[Id].Id);
    if(indexDispatch > -1)  {
      this.incidentService._assistanceDispacthList.splice(indexDispatch, 1);
      this.incidentService._assistanceDispacthList.push({Movil: movil?.label, VehicleID: this._assistanceClone.VehicleID, ServiceID: this._assistanceClone.ServiceID})
    }

    this.onRefreshGrid('dispatch');
  }

  async addLane(lane: CoreTypes.ITS_IncidentLanes, laneRoadwayID) {
    if (lane && lane?.LaneID != 0) {
      let findLane = this._laneFullList.find(l=> l.LaneID == lane.LaneID);
      let laneRoadway = this._laneRoadwayList.find(r => r.value == laneRoadwayID);
      let trafficDirections = this._trafficDirectionsList.find(t => t.value === lane?.DirectionID);
      await this.onSelectTrafficDirection();
      await this.getITSReasonsClosing();
      await this.getITSReasonsOpening();
      let exist = this._lanesInvolvedList.find(x => x.Id == findLane?.LaneID && !x.EndDateTime);
      if (!exist){
        let movil = this.incidentService._assistanceDispacthList?.find(t => t.VehicleID && t.VehicleID === lane.EmergencyVehicleID);
        let reason = lane.OpeningReasonID ? this._reasonLaneOpenList.find(x => x.value === lane.OpeningReasonID) : this._reasonLaneCloseList.find(x => x.value === lane.ClosureReasonID);
        // if(!this.incidentData.IncidentLanes?.length) this.incidentData.IncidentLanes = [];
        // this.incidentData.IncidentLanes.push({
        //   LaneID: lane?.LaneID,
        //   ClosureEndDateTime: (lane && lane.ClosureEndDateTime?.Date?.Day) ? lane.ClosureEndDateTime : new CoreTypes.DateTimeDT(),
        //   HasEnded: (lane && lane.ClosureEndDateTime?.Date?.Day) ? true : false,
        //   IncidentID: this.incidentData.Incident.IncidentID,
        //   RoadwayID: laneRoadwayID,
        //   ClosureStartDateTime: lane.ClosureStartDateTime,
        //   ClosureDuration: 0,
        //   ClosureLength: 0,
        //   EndKilometerPoint: lane.EndKilometerPoint ? +lane.EndKilometerPoint : lane.EndKilometerPoint,
        //   IncidentLaneID: 0,
        //   StartKilometerPoint: lane.StartKilometerPoint ? +lane.StartKilometerPoint : lane.StartKilometerPoint,
        //   ClosureReasonID: lane.ClosureReasonID,
        //   OpeningReasonID: lane.OpeningReasonID,
        //   EmergencyVehicleID: lane.EmergencyVehicleID,
        //   DirectionID: lane.DirectionID
        // });

        if(!this._lanesInvolvedList.length) this._lanesInvolvedList = [];
        this._lanesInvolvedList.push({
          Id: lane?.LaneID,
          VialAxis: "this._vialAxes?.label",
          TrafficDirection: trafficDirections?.label,
          LaneRoadway: laneRoadway?.label,
          Lane: findLane?.LaneName,
          StartDateTime: moment(this.stringDateTimePipe.transform(lane.ClosureStartDateTime)).format('DD-MM-YYYY HH:mm'),
          EndDateTime: (lane && lane.ClosureEndDateTime?.Date?.Day) ? moment(this.stringDateTimePipe.transform(lane.ClosureEndDateTime)).format('DD-MM-YYYY HH:mm') : null,
          Movil: movil?.Movil,
          Reason: reason?.label
        });
        if(!lane.ClosureEndDateTime || !lane.ClosureEndDateTime?.Date?.Day) {
          this.addItemToSection(this.incidentElementTypes.Lanes, lane.LaneID);
        }
      }
      setTimeout(() => {
        this.onRefreshGrid('lanes')
      }, 100);
    }
  }


  saveDataElements(params) {
    switch (params?.IncidentElementTypeID) {
      case this.incidentElementTypes.Dispatches:
        let assistance = JSON.parse(params.JsonData);
        if(params.Editing) {
          this._assistanceClone = assistance;
          // this.onEditDispatch(this._editId)
        } else {
          this.addDispatch(assistance);
        }
        break;
      case this.incidentElementTypes.Lanes:
        let lane: CoreTypes.ITS_IncidentLanes = JSON.parse(params.JsonData);
        if(params.Editing) {
          this._laneClone = lane;
          // this.onEditLane(this._editId)
        } else {
          // this.addLane(lane, lane?.RoadwayID);
        }
        break;
      case this.incidentElementTypes.InvolvedVehicles:
        let vehicle = JSON.parse(JSON.stringify(params.JsonData));
        if(params.Editing) {
          this.involvedVehicleClone = vehicle;
          // this.onEditVehicle(this._editId)
        } else {
          // this.addVehicle(vehicle);
        }
        break;
      case this.incidentElementTypes.InvolvedPeople:
        let person = JSON.parse(JSON.stringify(params.JsonData));
        if(params.Editing) {
          this.involvedPersonClone = person;
          // this.onEditPeople(this._editId)
        } else {
          // this.addPeople(person);
        }
        break;
      case this.incidentElementTypes.DamageRegister:
        let parameters = JSON.parse(params?.JsonData);
        if(!params.Editing) {
            // this.addDamage(parameters);
          } else {
            // this.onEditDamages(parameters)
            this.onRefreshGrid('damages');
          }
        break;
      case this.incidentElementTypes.Files:
        let files = JSON.parse(params?.JsonData);
        // !params.Editing ? this.addAttachments(files) : this.onEditFile(this._editId, files);
        break;
      default:
        break;
    }
  }

  onSave(formElement) {
    this.onCloseForm.emit(true);
  }

  refreshTabsData() {
    this.onRefreshGrid('lanes');
    this.onRefreshGrid('vehicles');
    this.onRefreshGrid('people');
    this.onRefreshGrid('dispatch');
    this.onRefreshGrid('damages');
    this.onRefreshGrid('file');
  }

  setDynamicEntries(columnsConfig, data) {
    const dataEntries: TableTypes.DataTable = {
      Columns: columnsConfig.map(col => ({
        Title: col.title,
        Alignment: col.alignment || 0,
        WidthPixels: col.width || 65
      })),
      Elements: this.formatDynamicElements(columnsConfig, data)
    };
    return dataEntries;
  }

  formatDynamicElements(columnsConfig, elements){
    let retElem = [];
    if (elements && elements.length > 0) {
      retElem = elements.map((x, i) => ({
        ElementID: i,
        Values: columnsConfig.map(col => x[col.key])
      }));
    }
    return retElem;
  }

  onRefreshGrid(item){
    switch(item) {
      case 'vehicles':
        const vehicleColumnsConfig = [
          { title: 'Patente', key: 'LicensePlate' },
          { title: 'Tipo', key: 'Type', alignment: 2 },
          { title: 'Color', key: 'Color', alignment: 2 },
          { title: 'Modelo', key: 'Model', alignment: 2 },
          { title: 'Año', key: 'VehicleYear', alignment: 2 },
          { title: 'Asistencia', key: 'AssistanceType', alignment: 2 },
          { title: 'Trasladado por', key: 'TransferredBy', alignment: 2 },
          { title: 'Destino', key: 'Destination', alignment: 2 },
        ];
        this._vehiclesInvolved = this.setDynamicEntries(vehicleColumnsConfig, this._vehiclesInvolvedList);
        this.onRefreshGrid('people');
        break;
      case 'lanes':
        const laneColumnsConfig = [
            { title:'Eje', alignment: 0, key: 'VialAxis', width: 65},
            { title:'Calzada', key: 'TrafficDirection', alignment: 2, width: 65},
            { title:'Via', key: 'LaneRoadway',alignment: 2, width: 65},
            { title:'Pista', key: 'Lane', alignment: 2, width: 65},
            { title:'Inicio', key: 'StartDateTime', alignment: 2,},
            { title:'Fin', key: 'EndDateTime', alignment: 2,},
            { title:'Móvil', key: 'Movil', alignment: 2,},
            { title:'Motivo', key: 'Reason', alignment: 2,},
        ];
        this._lanesInvolvedTable = this.setDynamicEntries(laneColumnsConfig, this._lanesInvolvedList);

        break;
      case 'dispatch':
        const dispatchColumnsConfig = [
          { title: 'Móvil', key: 'Movil' },
          { title: 'Despacho', key: 'DispatchDateTime', alignment: 2 },
          { title: 'Llegada', key: 'ArrivalDateTime', alignment: 2 },
          { title: 'Fin Asistencia', key: 'EndDateTime', alignment: 2 },
          { title: 'Asistencia', key: 'AssistanceType', alignment: 2 }
        ];
        this._dispatchTable = this.setDynamicEntries(dispatchColumnsConfig, this._dispatchList);
        break;
      case 'people':
        const peopleColumnsConfig = [
          { title: 'Nombre', key: 'FullName', alignment: 0 },
          // { title: 'N° Documento', key: 'DocumentNumber', alignment: 2 },
          { title: 'Tipo persona', key: 'PersonType', alignment: 2 },
          { title: 'Vehículo', key: 'Vehicle', alignment: 2 },
          { title: 'Asistencia', key: 'Assistance', alignment: 2 },
          { title: 'Condición', key: 'HealthCondition', alignment: 2 },
          { title: 'Móvil', key: 'Movil', alignment: 2 },
          { title: 'Destino', key: 'Destination', alignment: 2 },
        ];

        this._vehiclePersonList = [];
        if(!this._vehiclePersonList.length) { this._vehiclePersonList.push({ label: 'Ninguno', value:0 }) }
        this._vehiclesInvolvedList?.forEach(v => {
          this._vehiclePersonList.push({ label: v.LicensePlate, value: v.Id});
        });
        this._vehiclePerson = this._vehiclePersonList[0];
        this.incidentService.vehiclePersonList = this._vehiclePersonList;
        this._peopleInvolved = this.setDynamicEntries(peopleColumnsConfig, this._peopleInvolvedList);
        break;
      case 'damages':
        const damageColumnsConfig = [
          { title: 'Elemento', key: 'Damage' },
          { title: 'Cantidad', key: 'Quantity', alignment: 2 },
          { title: 'Comentarios', key: 'Comments', alignment: 2 },
        ];
        this._damageRegisterDataTable = this.setDynamicEntries(damageColumnsConfig, this._damageRegisterList);
        break;
      case 'file':
        const filesColumnsConfig = [
          { title: 'Nombre', key: 'FileName' },
          { title: 'Tipo', key: 'FileType', alignment: 2 },
          { title: 'Descripción', key: 'Description', alignment: 2 },
          { title: 'Fecha y Hora Creación', key: 'DateTimeCreated', alignment: 2 },
          { title: 'Fecha y Hora Modificación', key: 'DateTimeCreated', alignment: 2 },
        ];

        this._fileEvidenceTable = this.setDynamicEntries(filesColumnsConfig, this._fileEvidenceList);
        break;
      default:
        break;
    }
  }
  
  updateMaxDate() {
    this.today = new Date();
  }

  addItemToSection(sectionId: any, item: any): void {
    this.incidentService.addItemToSection(sectionId, item);
  }

  removeElementFromTable(sectionId:any, element: any): void {
    this.incidentService.removeSelectedItem(sectionId, element);
  }
  
  appendModalBody(type) {
    setTimeout(() => {
      if(type === 'append') {
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('incident-modal'));
      } else {
        document.getElementsByTagName('app-root')[0].removeChild(document.getElementById('incident-modal'));
      }
    }, 100);
  }
}
